import { type MCPServerInfo } from '../../types';

const GoogleWorkspaceServer: MCPServerInfo = {
  serverId: 'GOOGLE_WORKSPACE',
  name: 'Google Workspace',
  slug: 'google-workspace',
  description:
    'Comprehensive, highly performant Google Workspace Streamable HTTP & SSE MCP Server for Calendar, Gmail, Docs, Sheets, Slides & Drive',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google_workspace_mcp',
    commitSha: '057c2e2',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default GoogleWorkspaceServer;
